export const RATE_THIS_APP_DISMISSED = 'client_rateapp_dismissed';
export const RATE_THIS_APP_DISMISSED_TWICE = 'client_rateapp_dismissed_twice';
